import createRestfulModule from './restful-module'
const homeSettingKeys =  ['flagship', 'watch', 'digital-piano', 'e-education', 'calculator']
export default createRestfulModule({

  state: {
    path: 'member/activity/page-setting', // 资源路径
    defaultRels: [], // 默认需要的关联数据
    homeSettings: [],
  },

  mutations: {
    setHomeSetting(state, data) {
      state.homeSettings = data
    }
  },

  actions: {
    async getHomeSettings({ dispatch, state, commit}) {
      const query = {
        key: JSON.stringify(homeSettingKeys)
      }

      const { collection } = await dispatch('collection', { query } )
      commit('setHomeSetting', collection)
      return collection
    }
  }

})
